import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Button, Toast, TextArea, Checkbox } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
const api = new ApiCore();


const CSOPersonalCenter = (props: any) => {




    const [doctorInfo, setDoctorInfo] = useState<any>({});

    useEffect(() => {
        window.document.title = '个人中心'
        getInfo()
        return () => {
        }
    }, [])



    const getInfo = () => {
        api.getCsoDoctorInfo().then((res: any) => {
            if (res.code == 0) {
                if (res.data.code) {
                        res.data.code = res.data.code.replace(res.data.code.substring(3, 7), " **** ");
                }
                const _data = res.data || {};
                setDoctorInfo(_data)
            }
        });

    }


    const goBack = () => {
        props.history.go(-1)
    }

    return (
        <div className={styles.personalCenter_container}>

            <div className={styles.label}>身份信息</div>
            <div className={styles.content}>
                <div className={styles.info_item}>
                    <div className={styles.info_label}>姓名</div>
                    <div className={styles.info}>{doctorInfo && doctorInfo.name}</div>
                </div>
                <div className={styles.info_item}>
                    <div className={styles.info_label}>手机号</div>
                    <div className={styles.info}>{doctorInfo && doctorInfo.code}</div>
                </div>
                {
                    (doctorInfo?.identityType == 1 || doctorInfo?.identityType == 3) &&
                    <>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>省/市/区</div>
                            <div className={styles.info}>{doctorInfo && doctorInfo.province}{doctorInfo && doctorInfo.city}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>所属医院</div>
                            <div className={styles.info}>{doctorInfo && doctorInfo.institution}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>所属科室</div>
                            <div className={styles.info}>{(doctorInfo && doctorInfo.dept) ? doctorInfo.dept : '暂无数据'}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>职称</div>
                            <div className={styles.info}>{(doctorInfo && doctorInfo.title) ? doctorInfo.title : '暂无数据'}</div>
                        </div>
                    </>
                }
                {
                    (doctorInfo?.identityType == 2) &&
                    <>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>省/市/区</div>
                            <div className={styles.info}>{doctorInfo && doctorInfo.province}{doctorInfo && doctorInfo.city}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>执业类别</div>
                            <div className={styles.info}>{doctorInfo?.practiceType || '暂无数据'}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>执业范围</div>
                            <div className={styles.info}>{doctorInfo?.practiceScope || '暂无数据'}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>执业单位</div>
                            <div className={styles.info}>{doctorInfo?.practiceUnit || '暂无数据'}</div>
                        </div>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>药师职称</div>
                            <div className={styles.info}>{doctorInfo?.title || '暂无数据'}</div>
                        </div>
                    </>
                }
                {
                    (doctorInfo?.identityType == 4) &&
                    <>
                        <div className={styles.info_item}>
                            <div className={styles.info_label}>身份证</div>
                            <div className={styles.info}>{doctorInfo && doctorInfo.idCard && doctorInfo.idCard.replace(/\d{14}(\d{4})/, "**************$1")}</div>
                        </div>
                    </>
                }
            </div>

            <div className={styles.myButton}>
                <Button color='primary' fill='solid' onClick={goBack}>
                    返回
                </Button>
            </div>

        </div>
    )
}

export default withRouter(CSOPersonalCenter);